import axios from "../reducers/authinterceptor";
import AuthHeader from "./auth.header";

const loadInventory = async (styleId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sanmarLoadInventory/" + styleId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};
const updatePrices = async (styleId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sanmarUpdatePricesStyle/" + styleId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const downloadPO = async (poId) => {
  axios
    .get(process.env.REACT_APP_API_URL + "/admin/purchaseorder/report/" + poId,
      {
        headers: {
          ...AuthHeader.authHeader()
        },
        responseType: 'blob'
      }).then((response) => {
        console.log("HEADERS", response);
        // create file link in browser's memory
        const href = URL.createObjectURL(new Blob([response.data]));

        // create "a" HTML element with href to file & click
        const link = document.createElement('a');
        link.href = href;

        const fileNameHeader = "x-suggested-filename";
        const suggestedFileName = response.headers[fileNameHeader];

        link.setAttribute('download', suggestedFileName); //or any other extension
        document.body.appendChild(link);
        link.click();

        // clean up "a" element & remove ObjectURL
        document.body.removeChild(link);
        URL.revokeObjectURL(href);
      });

};

const removeFeatured = async (productId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/removefeatured/" + productId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const addFeatured = async (productId) => {
  try {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/addfeatured/" + productId,
        { headers: AuthHeader.authHeader() });
    console.log(response);
    return response.data;
  } catch (error) {
    console.log(error);
    if (error && error.response && error.response.data) {
      return error.response.data;
    }
    return { error: true, message: "Failed to set as featured" };
  }
};

const addPrintItemFeatured = async (printItemId) => {
  try {
    var response = await axios
      .get(process.env.REACT_APP_API_URL + "/admin/addfeatured/" + printItemId + "?printItem=1",
        { headers: AuthHeader.authHeader() });
    return response.data;
  } catch (error) {
    if (error && error.response && error.response.data) {
      return error.response.data;
    }
    return { error: true, message: "Failed to set as featured" };
  }
};

const removePrintItemFeatured = async (printItemId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/removefeatured/" + printItemId + "?printItem=1",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const getMaintenance = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/maintenance",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const allStyleReport = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/report/allStyles",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSanmarColors = async (productId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sanmarupdatecolors/" + productId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const refreshSandsProducts = async (productId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sands/refreshProducts/" + productId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const refreshSandsInventory = async (productId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sands/refreshInventory/" + productId,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSanmarSizes = async (productId) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sanmarupdatesizes",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSanmarSizesForStyle = async (styleCode) => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/sanmarupdatesizes/" + styleCode,
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const syncFromSDL = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/syncfromsdl",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const getIgniteProductsWithInventory = async () => {
  var response = await axios
    .get(process.env.REACT_APP_API_URL + "/admin/ignite/inventory",
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateIgniteInventory = async (productId, quantity) => {
  var response = await axios
    .post(process.env.REACT_APP_API_URL + "/admin/ignite/inventory",
      { productId, quantity },
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const bulkUpdateIgniteInventory = async (inventoryUpdates) => {
  var response = await axios
    .post(process.env.REACT_APP_API_URL + "/admin/ignite/inventory/bulk",
      { inventoryUpdates },
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const updateSizeNameOverride = async (sizeId, sizeNameOverride) => {
  var response = await axios
    .post(process.env.REACT_APP_API_URL + "/admin/size/" + sizeId + "/override",
      { sizeNameOverride },
      { headers: AuthHeader.authHeader() });
  return response.data;
};

const AdminService = {
  loadInventory,
  updatePrices,
  downloadPO,
  removeFeatured,
  addFeatured,
  addPrintItemFeatured,
  removePrintItemFeatured,
  getMaintenance,
  allStyleReport,
  updateSanmarColors,
  refreshSandsProducts,
  refreshSandsInventory,
  updateSanmarSizes,
  updateSanmarSizesForStyle,
  syncFromSDL,
  getIgniteProductsWithInventory,
  updateIgniteInventory,
  bulkUpdateIgniteInventory,
  updateSizeNameOverride

};
export default AdminService;